// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FrOI","rootNoMargin":"styles_rootNoMargin__1LFeT"};